module.exports = __webpack_public_path__ + "img/new1.27ae9af8.jpg";